import Tag from "datasets/pages/tables/types/interfaces/tag";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

export const PAGE_SIZE = 10;

const useTags = () => {
  return useFetcher<Tag[]>(`${VITE_CATALOG_API}/tags?limit=10000`);
};

export default useTags;
